import type React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@shadeables/supabase';

const ProtectedRoute: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
